import React, { useId } from "react";
import { ChevronIcon } from "./ui";

interface SustFeatureExpanderProps {
  title: string;
  headingLevel?: number;
  open: boolean;
  onChange: (isOpen: boolean) => void;
  onOpen?: () => void;
  children: React.ReactNode;
}

/**
 * Expander component for sustainability features.
 */
export const SustFeatureExpander: React.FC<SustFeatureExpanderProps> = ({
  title,
  headingLevel = 3,
  open,
  onChange,
  onOpen,
  children,
}) => {
  const headingId = useId();
  const regionId = useId();

  const HeadingTag = `h${headingLevel}` as keyof JSX.IntrinsicElements;

  return (
    <div className="sust-expander">
      <HeadingTag
        id={headingId}
        role="heading"
        aria-level={headingLevel}
        className="sust-expander__heading"
      >
        <button
          type="button"
          className="sust-expander__button"
          aria-expanded={open}
          aria-controls={regionId}
          onClick={() => {
            // Track when expander opens
            if (!open && onOpen) {
              onOpen();
            }
            onChange(!open);
          }}
        >
          <span className="sust-expander__title">{title}</span>
          <span className="sust-expander__icon">
            <ChevronIcon
              width={20}
              height={10}
              direction={open ? "up" : "down"}
            />
          </span>
        </button>
      </HeadingTag>
      {open && (
        <div
          id={regionId}
          role="region"
          aria-labelledby={headingId}
          className="sust-expander__region"
        >
          {children}
        </div>
      )}
    </div>
  );
};
